const sections = document.querySelectorAll('.accordion');

sections.forEach((section) => {
	const triggers = section.querySelectorAll('.open-accordion');
	if (!triggers.length) return;

	triggers.forEach((btn) => {
		const panel = btn.nextElementSibling;
		if (!panel) return;

		btn.addEventListener('click', () => {
			// Each item toggles independently — multiple panels can stay open.
			const isOpen = panel.classList.toggle('show');
			btn.classList.toggle('rotate', isOpen);
			btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
		});
	});
});
